export default function Footer() {
  const footerLinks = [
    {
      title: '内容导航',
      links: [
        { label: '精选推荐', href: '#cards' },
        { label: '热门话题', href: '#topics' },
        { label: '热播排行榜', href: '#ranking' },
        { label: '焦点专题', href: '#carousel' },
      ],
    },
    {
      title: '服务支持',
      links: [
        { label: '常见问题', href: '#faq' },
        { label: '用户评价', href: '#comments' },
        { label: '联系我们', href: '#contact' },
        { label: '关于我们', href: '#about' },
      ],
    },
    {
      title: '更多频道',
      links: [
        { label: '蜜桃视频专题', href: '#index' },
        { label: '红桃视频专题', href: '#index' },
        { label: '香蕉视频频道', href: '#index' },
        { label: '樱花视频频道', href: '#index' },
      ],
    },
  ];

  const handleLinkClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick('#hero');
              }}
              className="inline-block mb-4"
            >
              <span className="text-2xl font-bold text-primary-500 font-heading">
                日皮视频
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 max-w-[280px]">
              日皮视频汇聚蜜桃视频、红桃视频等独家推荐与特色专题，香蕉视频、樱花视频VIP会员免费看，高清流畅不缓冲，排行榜精选你感兴趣的好视频。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(link.href);
                      }}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 日皮视频. 本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-600">
              <span>合作伙伴</span>
              <span className="text-foreground-800">—</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}